














































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class OrderConstructoprFooter extends Vue {
  @Prop({ type: String, default: "" }) coast!: string;
}
